module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_06_770_280_vi-614fd5e5610ad309e13e4c07dbb3f88a.jpg";